import React, { useEffect, useState } from "react";
import OtpInput from "./OtpInput";

type Props = {
  length?: number;                               // default 6
  initialSeconds?: number;                        // default 30
  onVerify?: (code: string) => Promise<void> | void;  // wire backend later
  onResend?: () => Promise<void> | void;              // wire backend later
};

export default function OtpForm({
  length = 6,
  initialSeconds = 30,
  onVerify,
  onResend,
}: Props) {
  const [code, setCode] = useState("");
  const [seconds, setSeconds] = useState(initialSeconds);
  const [resending, setResending] = useState(false);

  // countdown
  useEffect(() => {
    if (seconds <= 0) return;
    const id = setInterval(() => setSeconds((s) => s - 1), 1000);
    return () => clearInterval(id);
  }, [seconds]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (code.length !== length) {
      alert(`Please enter the ${length}-digit code`);
      return;
    }
    if (onVerify) {
      await onVerify(code);
    } else {
      // keep the placeholder behavior
      alert(`Verify OTP: ${code}`);
    }
  };

  const resend = async () => {
    setResending(true);
    if (onResend) {
      await onResend();
    } else {
      // placeholder delay (keeps your UX)
      await new Promise((r) => setTimeout(r, 700));
    }
    setResending(false);
    setSeconds(initialSeconds);
  };

  return (
    <form onSubmit={handleSubmit} className="mt-6">
      <OtpInput value={code} onChange={setCode} length={length} />

      <button
        type="submit"
        className="mt-6 w-full rounded-xl bg-sky-500 py-2 text-sm font-semibold text-white transition hover:bg-sky-600"
        disabled={code.length !== length}
      >
        Verify
      </button>

      <div className="mt-4 flex flex-col items-center gap-2 text-xs">
        {seconds > 0 ? (
          <span className="text-gray-500">
            You can resend a new code in <b>{seconds}s</b>
          </span>
        ) : (
          <button
            onClick={resend}
            type="button"
            disabled={resending}
            className="text-sky-600 hover:text-sky-700 font-medium disabled:opacity-60"
          >
            {resending ? "Sending…" : "Resend code"}
          </button>
        )}
      </div>
    </form>
  );
}
